(function () {
  'use strict';

  /* @ngdoc object
   * @name manageUser
   * @description
   *
   */
  angular
    .module('manageUser', [
      'ui.router'
    ]);
}());
